import { Node, mergeAttributes } from '@tiptap/core';
export const ContentStyle = Node.create({
    name: 'contentStyle',
    group: 'block',
    draggable: true,
    atom: true,
    addAttributes() {
        return {
            styles: {
                default: [],
                renderHTML(attrs) {
                    return { 'data-styles': attrs.styles.join(',') };
                },
                parseHTML(element) {
                    const styles = element.getAttribute('data-styles');
                    return styles?.split(',') ?? [];
                },
            },
        };
    },
    addCommands() {
        return {
            setContentStyle: () => ({ commands }) => {
                return commands.insertContent({ type: this.name });
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'mb-content-style',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['mb-content-style', mergeAttributes(HTMLAttributes)];
    },
});
//# sourceMappingURL=content-style.js.map